var map = {
	"./91BM-017-NiniWu.jpg": "aW6w",
	"./91BM-018-GaozhiChen.jpg": "f6NE",
	"./91BM-019-GangLi.jpg": "cLET",
	"./91BM-020-GuopingYang.jpg": "zEVd",
	"./91BM-021-DerekLai.jpg": "6nk7",
	"./91BM-022-WeihuaLuo.jpg": "3hKx",
	"./91BM-023-QuanJiang.jpg": "KCLW",
	"./91BM-024-OliverNg.jpg": "e5Zz",
	"./91BM-025-JuLin.jpg": "5FbR",
	"./91BM-026-ZhiLi.jpg": "mE7I",
	"./91BM-027-ThomasFan.jpg": "4Hqr",
	"./91BM-028-WeiguoWu.jpg": "rwsU",
	"./91BM-029-MeifangLiu.jpg": "3N8j",
	"./91BM-030-StevenChiu.jpg": "68BC",
	"./91BM-031-XujiaYu.jpg": "aR8c",
	"./91BM-032-JingCao.jpg": "9+7Q",
	"./91BM-033-LipengZeng.jpg": "UsvX",
	"./91BM-034-FuguoYu.jpg": "osxi",
	"./91BM-035-LidanZhu.jpg": "WPb8",
	"./91BM-036-XiaofengLi.jpg": "BpY4",
	"./91BM-037-MinZhou.jpg": "Hbsy",
	"./91BM-038-FunuXin.jpg": "OX2q",
	"./91BM-039-AaronSun.jpg": "lvj9",
	"./91BM-040-ChunfangZhang.jpg": "WXSr",
	"./91BM-041-WinieLai.jpg": "zuqC",
	"./91BM-042-YanYin.jpg": "OXIi",
	"./91BM-043-YanjianHuang.jpg": "HAzL",
	"./91BM-044_PingChen.jpg": "yghX",
	"./91BM-045-YueZhang.jpg": "NzGR",
	"./91BM-046-YongleChen.jpg": "cV1g",
	"./91BM-047-ClarenceHung.jpg": "ErcZ",
	"./91BM-048-BensonGuo.jpg": "9bjc",
	"./91BM-049-AllenZhao.jpg": "j/7o",
	"./91BM-050-JimYu.jpg": "9vnm",
	"./91BM-051-MaxCai.jpg": "NOG0",
	"./91BM-052-HankDu.jpg": "epp1",
	"./91BM-053-AnnieZhang.jpg": "iiIW",
	"./91BM-054-JiajunLiu.jpg": "/+R9",
	"./91BM-055-BenChan.jpg": "BDyq",
	"./91BM-056-LuceZhang.jpg": "KXSJ",
	"./91BM-057-YuanyuanAn.jpg": "k6q9",
	"./91BM-058-HelenYan.jpg": "BYkb",
	"./91BM-059-QiangjiangWang.jpg": "FW6W",
	"./91BM-060-YonggangXiong.jpg": "M4y6",
	"./91BM-061-MaxMeng.jpg": "v3WC",
	"./91BM-062-StephenTsui.jpg": "IPyZ",
	"./91BM-063-JinhaiChen.jpg": "NeQO",
	"./91BM-064-MartinWei.jpg": "jIjE",
	"./91BM-065-JingSun.jpg": "s359",
	"./91BM-066-Norwin.jpg": "/vQ3",
	"./91BM-067-Gavin.jpg": "4q3M",
	"./91BM-068-LiuZhu.jpg": "Az9N",
	"./91BM-069-JackZhang.jpg": "KBfr",
	"./91BM-070-Morgan.jpg": "Tt8P",
	"./91BM-071-Li.jpg": "uqDa",
	"./91BM-072-Kitty.jpg": "iW2P",
	"./91BM-073-GuanGuan.jpg": "uTRx",
	"./andy.jpg": "OR3y",
	"./bill.jpg": "+uuU",
	"./carol.jpg": "mn7l",
	"./daniel.jpg": "Gp81",
	"./dong.jpg": "u52f",
	"./guoxiangwang.jpg": "lKZF",
	"./jessica.jpg": "aCmZ",
	"./jim.jpg": "mNCg",
	"./julie.jpg": "/gPG",
	"./jun_star.jpg": "+eej",
	"./kt.jpg": "8zcr",
	"./laurel.jpg": "jCvC",
	"./luchi.jpg": "t+Nk",
	"./rico_star.jpg": "olTf",
	"./rocky.jpg": "SPON",
	"./sa.jpg": "dgfC",
	"./six_star.png": "78UE",
	"./tina.jpg": "gh8E",
	"./wei.jpg": "QmSx",
	"./yi.jpg": "sUBK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b0WK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars ^\.\/.*$
// module id = b0WK
// module chunks = 0